/**
 * Application Configuration
 * 
 * All authentication is now handled via AWS Marketplace JWT tokens.
 * Cognito has been removed.
 */

// API Configuration
export const API_URL = import.meta.env.VITE_API_URL;
export const AWS_REGION = import.meta.env.VITE_AWS_REGION || 'us-east-1';
export const BUCKET_NAME = import.meta.env.VITE_BUCKET_NAME;

// AWS Marketplace public listing URL (per-product prodview slug)
export const MARKETPLACE_URL = import.meta.env.VITE_MARKETPLACE_URL || 'https://aws.amazon.com/marketplace';

// Auth mode is always marketplace now
export const AUTH_MODE = 'marketplace';
export const USE_MARKETPLACE_AUTH = true;
